import React, { useRef } from "react";
import IcColor from "../../../../../../../../../../../../../../../../Assets/Images/ImageEditorColor.svg";
import { useImageEditorContext } from "../../../../../../../../../../../../context/ImageEditorProvider";
import { MenuItem, Select } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { drawSizeOptions } from "../../../../../../constant/imageEditor.constant";
import "./ImageEditorDrawControl.scss";

const ImageEditorDrawControl = (props) => {
  const { DrawSize, setDrawSize } = useImageEditorContext();
  const colorInputRef = useRef(null);

  const handleOpenColorPicker = () => {
    if (colorInputRef.current) {
      colorInputRef.current.click();
    }
  };

  return (
    <div className="image-editor-draw-control" style={props.WrapperStyle}>
      <div className="draw-control__color">
        <input
          ref={colorInputRef}
          className="draw-control__color--input"
          type="color"
          value={props.Color}
          onChange={props.onChangeColor}
        />
        <img
          onClick={handleOpenColorPicker}
          src={IcColor}
          className="draw-control__color--icon"
          alt="icon"
        />
        <span>Color</span>
      </div>

      <div className="draw-control__size">
        <div className="draw-control__size--select-wrapper">
          <Select
            value={DrawSize}
            onChange={(e) => setDrawSize(e.target.value)}
            variant="outlined"
            IconComponent={ArrowDropDownIcon}
            size="small"
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "#caced1 !important",
              },

              "& .MuiSelect-select": {
                paddingTop: "0",
                paddingBottom: "0",
              },

              padding: "0",
              display: "flex",
              height: "34px",
              width: "100px",
              border: "1px solid #FB4764",
              borderRadius: "50px",
              fontSize: "12px",
            }}
          >
            {drawSizeOptions.map((drawSize) => {
              return (
                <MenuItem key={drawSize.value} value={drawSize.value}>
                  {drawSize.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
        <span>Size</span>
      </div>
    </div>
  );
};

export default ImageEditorDrawControl;
